import React, { useEffect, useState, useCallback } from "react";
import {
  TextField,
  Paper,
  Box,
  Button,
  Divider,
  IconButton,
  FormControlLabel,
  Switch,
  TablePagination,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  useMediaQuery,
} from "@mui/material";
import AuthService from "../../AuthService";
import Template from "../Generico/Template";
import BarraTitulo from "../Generico/BarraTitulo";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Cancel";
import DeleteIcon from "@mui/icons-material/Delete";
import { useSnackbar } from "notistack";
import { useTheme } from "@emotion/react";

function Chamado() {
  const service = new AuthService();
  const empresa = service.getProfile().empresa;
  const { enqueueSnackbar } = useSnackbar();

  const [chamados, setChamados] = useState([]);
  const [chInput, setChInput] = useState({ descricao: "", ativo: true });
  const [chamarGarcom, setChamarGarcom] = useState(empresa.chamarGarcom);
  const [open, setOpen] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);
  const theme = useTheme();
  const isTablet = useMediaQuery(theme.breakpoints.down("md"));
  const novoChamado = () => {
    setChInput({
      descricao: "",
      ativo: true,
      pausado: true,
    });
  };

  const handleListChamados = useCallback(() => {
    service
      .get("/tipoChamado/list")
      .then((retorno) => setChamados(retorno))
      .catch((err) => console.error(err));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    handleListChamados();
  }, [handleListChamados]);

  const handleClose = () => setOpen(false);

  const handleClickOpenNew = () => {
    setOpen(true);
    novoChamado();
  };

  const handleClickOpenEdit = (chamado) => {
    setOpen(true);
    setChInput({ ...chamado });
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setChInput((prev) => ({ ...prev, [name]: value }));
  };

  const handleDelete = (chamado, index) => {
    service
      .delete(`/tipoChamado/${chamado.id}`)
      .then(() => {
        setPage(0);
        const updatedChamados = [...chamados];
        updatedChamados.splice(index, 1);
        setChamados(updatedChamados);
        enqueueSnackbar("Chamado excluído com sucesso", { variant: "success" });
      })
      .catch((err) => {
        enqueueSnackbar(`Erro ao excluir o chamado. Detalhes: ${err.message}`, {
          variant: "error",
        });
      });
  };

  const handleSaveAll = () => {
    if (chInput.descricao === "") {
      enqueueSnackbar("Preencha o campo descrição.", { variant: "error" });
      return;
    }

    service
      .post("/tipoChamado", chInput)
      .then((resp) => {
        const updatedChamados = chamados.filter((ch) => ch.id !== chInput.id);
        updatedChamados.push(resp);
        setChamados(updatedChamados);
        setOpen(false);
        enqueueSnackbar("Salvo com sucesso.", { variant: "success" });
      })
      .catch((err) => {
        enqueueSnackbar("Erro ao cadastrar um novo chamado. " + err.message, {
          variant: "error",
        });
      });
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleClickStopAndPause = (event, chamado) => {
    event.preventDefault();
    event.stopPropagation();

    service
      .post(`/tipoChamado/pausar/${chamado.id}/${!chamado.pausado}`)
      .then((retorno) => {
        chamado.pausado = retorno.pausado;
        setChamados([...chamados]);
      })
      .catch((err) => {
        console.error("Falha ao pausar/startar chamado", err);
      });

    return false;
  };

  const alterarConfiguracao = (flagChamarGarcom) => {
    const empresa = service.getProfile().empresa;
    const empresaChange = { id: empresa.id, chamarGarcom: flagChamarGarcom };

    service
      .put("/empresa/changeOnly", empresaChange)
      .then((retorno) => {
        setChamarGarcom(retorno.chamarGarcom);
        let profile = service.getProfile();
        profile.empresa = retorno;
        localStorage.setItem("_profile", JSON.stringify(profile));
      })
      .catch((err) => console.error(err));
  };

  return (
    <Template documentTitle="Cadastro de chamados">
      <Box
        display="flex"
        flexDirection={isTablet ? "column" : "row"}
        justifyContent="space-between"
        alignItems="flex-end"
      >
        <Box sx={{ width: "100%" }}>
          <BarraTitulo
            title="Cadastro de chamados"
            subTitle="Configure os chamados"
          />
        </Box>

        <Box
          sx={{
            width: isTablet ? "100%" : "auto",
            minWidth: "10rem",
            marginBottom: "0.75rem",
          }}
        >
          <Button
            color="primary"
            variant="contained"
            startIcon={<AddIcon />}
            fullWidth
            size="medium"
            onClick={handleClickOpenNew}
          >
            Chamado
          </Button>
        </Box>
      </Box>

      <Paper>
        <Box p={3}>
          <Box p={2} display="inline">
            <FormControlLabel
              control={
                <Switch
                  checked={chamarGarcom}
                  name="chamarGarcom"
                  color="primary"
                  onChange={() => alterarConfiguracao(!chamarGarcom)}
                />
              }
              label="Ativar chamado do garçom"
            />
          </Box>
        </Box>

        <Divider />

        <Box p={3}>
          <TableContainer>
            <Table sx={{ minWidth: 600 }} size="small">
              <TableHead>
                <TableRow>
                  <TableCell align="left">Descrição</TableCell>
                  <TableCell align="right">Visível</TableCell>
                  <TableCell align="right" />
                </TableRow>
              </TableHead>

              <TableBody>
                {chamados
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((chamado, index) => (
                    <TableRow key={chamado.id}>
                      <TableCell align="left">{chamado.descricao}</TableCell>
                      <TableCell align="right">
                        <FormControlLabel
                          control={
                            <Switch
                              checked={chamado.pausado}
                              color="primary"
                              onChange={(event) =>
                                handleClickStopAndPause(event, chamado)
                              }
                            />
                          }
                        />
                      </TableCell>
                      <TableCell align="right">
                        <Button
                          onClick={() => handleClickOpenEdit(chamado)}
                          startIcon={<EditIcon />}
                        >
                          Editar
                        </Button>
                        <IconButton
                          aria-label="delete"
                          onClick={() => handleDelete(chamado, index)}
                          size="large"
                        >
                          <DeleteIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>

            <TablePagination
              rowsPerPageOptions={[5, 10, 25]}
              component="div"
              labelRowsPerPage="Linhas por página"
              count={chamados.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </TableContainer>
        </Box>
      </Paper>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="max-width-dialog-title"
        fullWidth
      >
        <DialogTitle id="max-width-dialog-title">Chamado</DialogTitle>
        <DialogContent>
          <Box p={2}>
            <Grid container spacing={2}>
              <Grid size={12}>
                <TextField
                  required
                  onChange={handleChange}
                  value={chInput.descricao || ""}
                  variant="outlined"
                  label="Descrição"
                  name="descricao"
                  fullWidth
                />
              </Grid>
            </Grid>
          </Box>
        </DialogContent>

        <DialogActions>
          <Button
            color="primary"
            variant="text"
            onClick={handleClose}
            startIcon={<CancelIcon />}
          >
            Cancelar
          </Button>
          <Button
            variant="contained"
            color="secondary"
            onClick={handleSaveAll}
            startIcon={<SaveIcon />}
          >
            Salvar
          </Button>
        </DialogActions>
      </Dialog>
    </Template>
  );
}

export default Chamado;
